package uz.ferro.erp.feature.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class EmailPreConfirmationResult(
    val message: String?
)